(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define([], factory);
    } else if (typeof exports === 'object') {
        // CommonJS
        module.exports = factory();
    } else {
        // Browser globals (Note: root is window)
        root.ChatBotUtils = factory();
    }

})(this, function () {

    var translations = {};

    function initBotTranslations() {

        // set translation based on the bot location
        // in G1/G2 from jsModelUI
        if (typeof jsModelUI !== 'undefined' && typeof jsModelUI.uiChatBot !== 'undefined') {
            translations.textErrorMessageBot = jsModelUI.uiChatBot.textErrorMessageBot;
            translations.labelInputPlaceholderBot = jsModelUI.uiChatBot.labelInputPlaceholderBot;
            translations.labelShowAll = jsModelUI.uiChatBot.textShowAllBot;
            translations.textSelectedCategory = jsModelUI.uiChatBot.textSelectionCategoryBot;
            translations.labelGoToDetailsBot = jsModelUI.uiChatBot.textGoToDetailsBot;
            translations.labelBotTitle = jsModelUI.uiChatBot.labelBotTitle;
            translations.labelListening = jsModelUI.uiChatBot.labelListening;
            translations.labelNoMicrophone = jsModelUI.uiChatBot.labelNoMicrophone;
            translations.msgRequestFailed = jsModelUI.uiChatBot.msgRequestFailed;
            translations.msgClose = jsModelUI.uiChatBot.msgClose;
            translations.msgConfirm = jsModelUI.uiChatBot.msgConfirm;
            translations.textInternalContacts = jsModelUI.uiChatBot.labelInternalContacts;
            translations.textSupplierContacts = jsModelUI.uiChatBot.labelSupplierContacts;
            translations.textShowHistory = jsModelUI.uiChatBot.textShowHistory;
            translations.labelGoToSynerSpace = jsModelUI.uiChatBot.labelGoToSynerSpace;
            translations.msgNoOnlineUsers = jsModelUI.uiChatBot.msgNoOnlineUsers;
            translations.buttonYes = jsModelUI.uiChatBot.buttonYes;
            translations.buttonNo = jsModelUI.uiChatBot.buttonNo;
        } else {
            // in login translations are set on window from login.jsp
            translations.textErrorMessageBot = window.textErrorMessageBot;
            translations.labelInputPlaceholderBot = window.labelInputPlaceholderBot;
            translations.labelBotTitle = window.labelBotTitle;
            translations.labelListening = window.labelListening;
            translations.labelNoMicrophone = window.labelNoMicrophone;
            translations.msgRequestFailed = window.msgRequestFailed;
        }

        return translations;
    }

    function generateMessageMarkup(data, timestamp, messagePosition, participant, querySessionToken) {
        var messageMarkup = "";
        var message = "";

        // complex message that requires special markup
        switch (data.actionType) {
            case "searchCategories":
            case "list":
                message = generateActionMessages(data);
                messageMarkup = generateAnswerPosition(message, timestamp, messagePosition, participant);
                break;
            case "advancedSearch":
                message = generateAdvancedSearchMessage(data);
                messageMarkup = generateAnswerPosition(message, timestamp, messagePosition, participant);
                break;
            case "recentOrders":
            case "searchWebshop":
            case "WFYA":
                message = generateCardsMessage(data, querySessionToken);
                messageMarkup = generateAnswerPosition(message, timestamp, messagePosition, participant);
                break;
            case "onlineUsers":
                messageMarkup = generateOnlineUsersList(data, timestamp, querySessionToken);
                break;
            default:
                message = generateSimpleMessage(data, participant);
                messageMarkup = generateAnswerPosition(message, timestamp, messagePosition, participant);
        }

        return messageMarkup;
    }

    function generateAnswerPosition(message, timestamp, messagePosition, participant) {
        return "<div class='direct-chat-msg " + messagePosition + "' data-user='" + participant + "'>" +
            "           <div class='direct-chat-info'>" +
            "               <span class='direct-chat-timestamp'>" + timestamp + "</span>" +
            "           </div>" +
            "           <div class='direct-chat-text'>" +
            "               <div>" + message + "</div>" +
            "           </div>" +
            "      </div>";
    }

    function generateSimpleMessage(data, participant) {
        // simple message received from server
        var message = data.message || "";

        if (participant === "he" && message) {

            marked.setOptions({
                breaks: true
            });

            message = marked(message);

            message = "<div class='markdown'>" + message + "</div>"
        }

        // add show all message only when showMoreLink is present
        if (data.goToSynerSpace) {
            // on G1 is window.contextPath
            // on G2 is jsModelUI.coreContextPath
            var contextPath = window.contextPath ? window.contextPath : jsModelUI.coreContextPath;

            var link = contextPath + "/wui/ng-apps/dist/ssp";
            message += generateLinkMarkup(link, translations.labelGoToSynerSpace);
        }

        return message
    }

    /**
     * Generate markup for search categories message
     * @param data
     * @returns {string}
     */
    function generateActionMessages(data) {
        var actionMessage;
        var message = "<div>" + data.message + "</div>" +
            "               <ul class='itemList'>";

        for (var i = 0; i < data.results.length; i++) {

            switch (data.actionType) {
                case "searchCategories":
                    actionMessage = data.results[i].type;
                    break;
                case "list":
                    actionMessage = data.results[i].name;
                    break;
            }

            message += "        <li class='item'>" +
                "                   <a class='itemCategory actionLink' data-action-message ='" + actionMessage + "' data-category-name='" + data.results[i].name + "'>" + data.results[i].name + "</a>" +
                "               </li>";
        }

        message += "        </ul>";

        return message;
    }

    /**
     * Generate markup for advanced search message
     * @param data
     * @returns {string}
     */
    function generateAdvancedSearchMessage(data) {
        var message = "<div>" + data.message + "</div>";
        // on G1 is window.contextPath
        // on G2 is jsModelUI.coreContextPath
        var contextPath = window.contextPath ? window.contextPath : jsModelUI.coreContextPath;
        var link = contextPath + "/wui/ng-apps/dist/ssp#search/" + data.results[0].query + "/" + data.results[0].name;

        var records = data.results[0].records;

        if (records.length > 0) {
            message += "<ul class='itemList'>";
            for (var i = 0; i < records.length; i++) {
                message += "<li class='item'>" +
                    "           <a class='actionLink' href='" + records[i].openItem + "'>" + records[i].title + " (" + records[i].externalId + ")</a>" +
                    "       </li>";
            }
            message += "</ul>";
        }

        if (data.results[0].totalRecords > records.length) {
            message += generateLinkMarkup(link, translations.labelShowAll);
        }

        return message;
    }


    function generateCardsMessage(data, querySessionToken) {
        var message = "<div>" + data.message + "</div>" +
            "          <div class='itemsList owl-carousel'>";
        var records = data.results;

        if (records.length > 0) {
            for (var i = 0; i < records.length; i++) {
                var fields = records[i].fields;
                var title = '';
                if (records[i].title) {
                    var proxyUserClass = "";

                    // used only for WFYA feature
                    if (records[i].proxyUser) {
                        proxyUserClass = "proxyUser"
                    }

                    title = "<div class='cardTitle appIcon " + records[i].appExternalId + " " + proxyUserClass + " " + records[i].statusColor + "' title='" + records[i].title + "'>" + records[i].title + "</div>"
                }
                message += "<div class='card '>" + title +
                    "           <div class='cardContent'>" +
                    "               <ul class='detailsList'>";

                for (var j = 0; j < fields.length; j++) {
                    message += generateListItem(fields[j], data, querySessionToken);
                }
                message += "        </ul>";

                message += generateLinkMarkup(records[i].openItemLink, translations.labelGoToDetailsBot, records[i]);
                message += "    </div>" +
                    "       </div>";
            }
        }

        // end itemsList owl-carousel
        message += "</div>";

        if (data.showMoreLink) {
            message += generateLinkMarkup(data.showMoreLink, translations.labelShowAll);
        } else if (data.actionType === "WFYA") {
            // on G1 is window.contextPath
            // on G2 is jsModelUI.coreContextPath
            var contextPath = window.contextPath ? window.contextPath : jsModelUI.coreContextPath;

            var link = contextPath + "/wui/ng-apps/dist/ssp";
            message += generateLinkMarkup(link, translations.labelGoToSynerSpace);
        }

        return message;
    }


    function generateListItem(field, data, querySessionToken) {
        var fieldValue = "";

        if (field.value) {
            fieldValue = field.value
        }

        var listItem = {
            cls: "",
            title: field.label + ": " + fieldValue,
            content: ""
        };

        if (data.actionType === "searchWebshop") {
            listItem.cls = "itemValue";

            if (field.type === "image") {
                listItem.title = "";
                var imageLink = '../../wui/cat/resources/images/product_details_icon.png';

                if (field.link && querySessionToken) {
                    imageLink = FormatUtil.addQuerySessionToken(field.link, querySessionToken);
                }

                // imgContainer has 90px height in order to help slimScroll to work correctly
                listItem.content = "<div class='imgContainer'>" +
                    "                   <img class='productImage' src='" + imageLink + "'/>" +
                    "               </div>";

            } else {
                if (field.link) {
                    // create clickable text when link is provided
                    // for webshop put only value for link
                    listItem.content = "<a href='" + listItem.link + "'>" + fieldValue + "</a>";
                } else {
                    listItem.content = fieldValue;
                }
            }
        } else if (data.actionType === "WFYA") {

            listItem.content = fieldValue;
            listItem.cls = "truncateText";

        } else {
            if (field.type === "text") {
                if (field.link) {
                    // create clickable text when link is provided with label in front of it
                    listItem.content = field.label + ": <a href='" + listItem.link + "'>" + fieldValue + "</a>";
                } else {
                    listItem.content = "<span class='" + listItem.cls + "'>" + field.label + ": </span>" + fieldValue;
                }
            }
        }

        return "<li class='detailsListItem " + listItem.cls + "' title='" + listItem.title + "'>" + listItem.content + "</li>";
    }

    /**
     * Generate markup for show all mechanism based on link
     * @param link
     * @param label
     * @param data
     * @returns {string}
     */
    function generateLinkMarkup(link, label, data) {
        var proxyUserClass = "";
        var proxyUserMsg = "";
        var urlForProxyUser = "";

        if (data && data.proxyUser) {
            proxyUserClass = 'proxyUserRequire';
            proxyUserMsg = "data-proxy-user-msg ='" + data.proxyUserMsg + "'";
            urlForProxyUser = "data-url-for-proxy-user ='" + data.urlForProxyUser + "'";
        }

        return "<div class='linkContainer'>" +
            "       <a class='actionLink " + proxyUserClass + "' " + proxyUserMsg + " " + urlForProxyUser + " href='" + link + "'>" + label + "</a>" +
            "   </div>";
    }

    function generateOnlineUsersList(data, timestamp, querySessionToken) {
        var message = '';
        // append first message on online users
        // in order to display message and link separately, a new object is send to appendMessage method with message only
        var dataMessage = {
            message: data.message
        };
        message += generateMessageMarkup(dataMessage, timestamp, "left", "he");

        message += "<div class='direct-chat-msg-onlineUsersList'>" + generateOnlineUsersMarkup(data.results, querySessionToken) + "</div>";

        // append online users list link for the entire list
        // in order to display message and link separately, a new object is send to appendMessage method with link only
        var dataShowMore = {
            goToSynerSpace: true
        };
        message += generateMessageMarkup(dataShowMore, timestamp, "left", "he");

        return message;
    }

    /**
     * Build markup for both internal and supplier users
     * @param users
     * @param querySessionToken
     * @returns {string}
     */
    function generateOnlineUsersMarkup(users, querySessionToken) {
        var hasInternalContacts = false;
        var hasSupplierContacts = false;

        var internalContactsMarkup = "<div class='header'>" + translations.textInternalContacts + "</div>" +
            "                               <div class='usersContainer'>";

        var supplierContactsMarkup = "<div class='header'>" + translations.textSupplierContacts + "</div>" +
            "                               <div class='usersContainer'>";

        for (var i = 0; i < users.length; i++) {
            if (users[i].type === 2) {
                hasInternalContacts = true;
                internalContactsMarkup += generateOnlineUserItem(users[i], querySessionToken);
            } else {
                hasSupplierContacts = true;
                supplierContactsMarkup += generateOnlineUserItem(users[i], querySessionToken);
            }
        }

        if (!hasInternalContacts) {
            internalContactsMarkup += "<div class='noOnlineUsers'>" + translations.msgNoOnlineUsers + "</div>";
        }

        if (!hasSupplierContacts) {
            supplierContactsMarkup += "<div class='noOnlineUsers'>" + translations.msgNoOnlineUsers + "</div>";
        }

        internalContactsMarkup += "</div>";
        supplierContactsMarkup += "</div>";

        return internalContactsMarkup + supplierContactsMarkup;
    }

    /**
     * Build markup for one user
     * @param item
     * @param querySessionToken
     * @returns {string}
     */
    function generateOnlineUserItem(item, querySessionToken) {
        var fields = JSON.stringify(item.fields);
        var imgLink = "../../wui/ssp/resources/images/user_general_dark.png";

        if (item.imgLink) {
            imgLink = FormatUtil.addQuerySessionToken(item.imgLink, querySessionToken);
        }

        return "<div class='userItemContainer' data-link='" + item.openItemLink + "' title='" + fields + "'>" +
            "       <div class='userImgContainer'>" +
            "           <img class='userImg' src='" + imgLink + "'/>" +
            "       </div>" +
            "       <div class='userName'>" + item.name + "</div>" +
            "   </div>";
    }

    return {
        generateMessageMarkup: generateMessageMarkup,
        initBotTranslations: initBotTranslations
    }
});
